var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo__logomark nav__logo-logomark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5h-2.7v.3c0 4-3.3 6.4-6.3 6.4s-6.3-2.4-6.3-6.4v-.3H0v.3c0 5.5 4.5 9.1 9 9.1s9-3.6 9-9.1v-.3zM9 3.4L10.9 6h3.4C12.7 3.9 11 1.8 9 0 7 1.8 5.3 3.9 3.7 6h3.4L9 3.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.6,
    cy: 10.3,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10.3,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4,
    cy: 10.3,
    r: 1.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 23.5h-3.2v-2.6c-1.7 2.1-4 3.1-6.7 3.1s-5.1-.9-6.7-2.5c-1.6-1.6-2.6-3.9-2.6-6.6 0-2.8.9-5 2.6-6.6 1.7-1.6 4-2.5 6.7-2.5 2.9 0 4.9.9 6.7 2.9V0h3.2v23.5zM31.2 8.6c-3.9 0-6.3 2.3-6.3 6.3 0 3.9 2.4 6.2 6.3 6.2 4 0 6.4-2.3 6.4-6.2 0-3.9-2.4-6.3-6.4-6.3zm24 .3h-7.7V24h-3.1V6h10.8zm2.4-7c0-.7.3-1.3.9-1.6.6-.4 1.2-.4 1.8 0 .6.3.9.9.9 1.6 0 .7-.3 1.4-.9 1.7-.6.4-1.2.4-1.8 0-.6-.3-.9-1-.9-1.7zm.3 4.3h3V24h-3V6.2zm6.9.2H68V9c1.6-1.9 3.7-3 6.7-3 2.7 0 5 .9 6.7 2.5 1.7 1.6 2.6 3.9 2.6 6.6 0 2.8-.9 5-2.6 6.6-1.7 1.6-4 2.5-6.8 2.5s-4.8-.9-6.6-2.9V30h-3.2V6.4zm9.5 15c4 0 6.4-2.3 6.4-6.3 0-3.9-2.4-6.2-6.4-6.2-3.9 0-6.3 2.3-6.3 6.2 0 3.9 2.4 6.3 6.3 6.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrip);
export default __webpack_public_path__ + "static/media/drip.0fabb1baf1de67761ab735eb3ee11f0a.svg";
export { ForwardRef as ReactComponent };